import React from 'react';
import BankDetailsCard from '../../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/BankDetailsCard';
import RefundAccountsCard from '../../../../studentRefundRequest/multiTypeRefund/selectRefundAccounts/RefundAccountsCard';
import EyeIcon from "assets/img/svg/svgComponents/EyeIcon";

const ViewRefundAccounts = ({
    refundAccountDetails = [],
    dropdownData
}) => {
    return (
        // <div className='a-card m-0'>
        //     <h3>Refund Accounts</h3>
        //     <div className='d-flex flex-wrap' style={{ gap: '0.5rem' }}>
        //         {
        //             refundAccountDetails?.map(details =>
        //                 <BankDetailsCard
        //                     accountDetails={details}
        //                     key={JSON.stringify(details)}
        //                     showBeneficiaryTypeChip
        //                 />
        //             )
        //         }


        //     </div>
        // </div>
        <RefundAccountsCard
        title={"Refund Accounts"}
        multiTypeRefundUtils={dropdownData?.data}
        accountDetails={refundAccountDetails}
        viewOnly={true}
        openDetailsDialogIcon={<EyeIcon/>}
        showBeneficiaryTypeChip={true}
        />
    );
}

export default ViewRefundAccounts;